import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import { useStore, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import { formValueSelector, change } from "redux-form";
import { uuidv4 } from "../../../utilities/utilities";
import AnswerContainer from "./AnswerContainer";
import { ListContainer } from "../../../utilities/linkedList";
import DefaultFormTextField from "../../DefaultFormTextField";
import { required } from "../../../utilities/validators";
import FormCheckBox from "../../FormCheckBox";
import PIDataToggle from "../../PIDataToggle";
const selector = formValueSelector("createQuestion");
const requiredValidator = required;

export default forwardRef((props, ref) => {
  const { showScoreEntry } = props;
  const intl = useIntl();
  const [answers, setAnswers, question] = useState();
  const [questionText, setQuestionText] = useState("");
  const [instructionText, setInstructionText] = useState("");
  const [showAddMore, setShowAddMore] = useState(false);
  const [showEnterAnswer, setShowEnterAnswer] = useState(true);
  const [answerList, setAnswerList] = useState(new ListContainer());
  const [isCodeQuestion, setIsCodeQuestion] = useState(false);
  const store = useStore();
  const dispatch = useDispatch();

  useImperativeHandle(ref, () => ({
    getQuestion() {
      let a = [];
      if (answers) {
        let i = 0;
        answerList.getList().traverse((r) => {
          let answer = r.data.ref.current.getAnswer();

          a.push({ answer, sortOrder: i });
          i++;
        });
      }

      return {
        id: uuidv4().replace("-", ""),
        title: selector(store.getState(), "question"),
        type: "single",
        instructions: selector(store.getState(), "instructions"),
        tag: selector(store.getState(), "tag"),
        answers: a,
        isOptional: selector(store.getState(), "isOptional"),
        isPiData: selector(store.getState(), "isPiData"),
        isDropdown: selector(store.getState(), "isDropdown"),
        isConsentRequired: selector(store.getState(), "isConsentRequired"),
        isCodeQuestion: isCodeQuestion,
        questionCode: selector(store.getState(), "questionCode"),
        displayInstructionAsIcon: selector(
          store.getState(),
          "displayInstructionAsIcon",
        ),
      };
    },
  }));

  const onDeleteAnswerClick = (answer) => {
    if (answer) {
      let x = answer.data.id;
      answerList.getList().remove(answer);
      setAnswerList(answerList);

      var a = answers.filter((r) => r.data.id !== x);
      setAnswers(a);
    }
  };

  const swapAnswer = (nodeA, nodeB) => {
    if (answerList) {
      answerList.getList().swap(nodeA, nodeB);

      let questionAnswers = new Array(0);

      answerList.getList().traverse((r) => {
        questionAnswers.push(r);
      });
      setAnswerList(answerList);
      setAnswers(questionAnswers);
    }
  };

  const onAddClick = (answer) => {
    setShowAddMore(true);
    setShowEnterAnswer(false);

    answer.id = uuidv4().replace("-", "");
    if (answerList) {
      answerList.getList().append(answer);
      let questionAnswers = new Array(0);

      answerList.getList().traverse((r) => {
        questionAnswers.push(r);
      });
      setAnswerList(answerList);

      setAnswers(questionAnswers);
    }
  };

  useEffect(() => {
    onAddNewAnswer();
  }, []);

  useEffect(() => {
    var el = document.getElementsByName("tag");
    if (el != null) {
      el[0].focus();
    }
  }, []);

  const onAddNewAnswer = () => {
    let answer = {};
    answer.id = uuidv4().replace("-", "");

    if (answerList) {
      answerList.getList().append(answer);
      let questionAnswers = new Array(0);

      answerList.getList().traverse((r) => {
        questionAnswers.push(r);
      });
      setAnswerList(answerList);

      setAnswers(questionAnswers);
    }
  };

  return (
    <Grid container direction="column" alignItems="flex-start">
      <Grid item style={{ width: "100%" }}>
        <PIDataToggle
          defaultValue={false}
          onChange={(value) =>
            dispatch(change("createQuestion", "isPiData", value))
          }
        />
      </Grid>
      <Grid item style={{ width: "100%" }}>
        <DefaultFormTextField
          label="Tag"
          variant="filled"
          name="tag"
          validators={[requiredValidator]}
          fullWidth
          inputProps={{ maxLength: 254 }}
          maxLength={254}
        />
      </Grid>
      <Grid item style={{ width: "100%" }}>
        <DefaultFormTextField
          label="Question"
          variant="filled"
          fullWidth
          name="question"
          validators={[requiredValidator]}
          inputProps={{ maxLength: 1023 }}
          maxLength={1023}
        />
      </Grid>

      <Grid
        item
        style={{ width: "100%", paddingBottom: "20px", paddingTop: "10px" }}
      >
        <DefaultFormTextField
          label="Instructions"
          variant="filled"
          fullWidth
          name="instructions"
          inputProps={{ maxLength: 2047 }}
          maxLength={2047}
          rows="3"
          multiline
        />
      </Grid>
      <FormCheckBox
        name="displayInstructionAsIcon"
        color="primary"
        label={intl.formatMessage({
          id: "app.survey.questions.displayInstructionAsIcon",
        })}
      />
      <FormCheckBox
        name="isOptional"
        color="primary"
        label={intl.formatMessage({ id: "app.survey.questions.isOptional" })}
      />
      <Grid item style={{ width: "100%" }}>
        <FormCheckBox
          name="isDropdown"
          color="primary"
          label={intl.formatMessage({
            id: "app.survey.questions.displayAsDropdown",
          })}
        />
      </Grid>
      <FormCheckBox
        name="isCodeQuestion"
        color="primary"
        onChange={(e) => setIsCodeQuestion(e.target.checked)}
        label={intl.formatMessage({
          id: "app.survey.questions.isCodeQuestion",
        })}
      />
      {/* <FormCheckBox
                name="isConsentRequired"
                color="primary"
                label={intl.formatMessage({ id: 'app.survey.questions.isConsentRequired.checkBox' })}
            /> */}

      {isCodeQuestion && (
        <Grid
          item
          style={{ width: "100%", paddingBottom: "20px", paddingTop: "10px" }}
        >
          <DefaultFormTextField
            label={intl.formatMessage({
              id: "app.survey.questions.questionCodeLabel",
            })}
            variant="filled"
            fullWidth
            name="questionCode"
            inputProps={{ maxLength: 255 }}
            maxLength={255}
          />
        </Grid>
      )}
      <Grid item>
        <Typography
          variant="h4"
          style={{
            fontWeight: "400",
            paddingTop: "10px",
            paddingBottom: "10px",
          }}
        >
          Possible Answers
        </Typography>
      </Grid>

      {answers &&
        answers.map((r, i) => {
          return (
            <Grid
              key={r.data.id}
              item
              style={{ width: "100%", padding: "10px 0 10px 30px " }}
            >
              <AnswerContainer
                key={r.data.id}
                answer={r}
                onDeleteAnswerCallback={onDeleteAnswerClick}
                onSwapRequestedCallback={swapAnswer}
                showScoreEntry={showScoreEntry}
                showCode={isCodeQuestion}
              />
            </Grid>
          );
        })}

      {/* {showEnterAnswer && (
				<Grid item style={{ width: '100%' }}>
					<AddAnswerControl onAddClick={onAddClick} />
				</Grid>
			)} */}

      <Grid
        item
        style={{ width: "100%", paddingTop: "10px", alignSelf: "center" }}
      >
        <Button
          variant="outlined"
          fullWidth
          color="secondary"
          onClick={onAddNewAnswer}
        >
          Add Another Answer
        </Button>
      </Grid>
    </Grid>
  );
});
